export default __webpack_public_path__ + "static/media/bj.d9433390.svg";